import { store } from '../state.js';
import { formatMoney, daysAgo } from '../utils.js';
import { priceFor } from '../store.js';
import { APPLIANCE_DIRECTIONS, DIRECTIONS_BY_ID, iconsSprite } from '../directionsData.js';
import { CITIES } from '../data.js';

let expandedCityId = null;

function leadsCount30d(directionId) {
    const cutoff = daysAgo(30);
    return store.get().leads.filter(l => l.directionId === directionId && l.createdAt >= cutoff).length;
}

function cityLeadsCount30d(cityId) {
    const cutoff = daysAgo(30);
    return store.get().leads.filter(l => l.cityId === cityId && l.createdAt >= cutoff).length;
}

function minPriceForCity(city) {
    const prices = APPLIANCE_DIRECTIONS
        .filter(d => store.get().directions[d.id] && store.get().directions[d.id].active)
        .map(d => priceFor(d.id, city));
    return prices.length ? Math.min(...prices) : priceFor('fridges', city);
}

function directionsListMarkup(state) {
    return APPLIANCE_DIRECTIONS.map(d => {
        const dirState = state.directions[d.id] || { active: false, pending: false };
        const price = priceFor(d.id, CITIES[0]);
        return `
            <div class="dir-row">
                <span class="dir-row__icon"><svg><use href="${iconsSprite}#icon-${d.icon}"></use></svg></span>
                <div class="dir-row__info">
                    <div class="dir-row__title">${d.title}</div>
                    <div class="dir-row__meta">${leadsCount30d(d.id)} заявок за 30 дней</div>
                </div>
                <div class="dir-row__price">
                    <div class="dir-row__price-val">${formatMoney(price)}</div>
                    <div class="dir-row__price-sub">Москва</div>
                </div>
                ${dirState.pending
                    ? `<span class="dir-row__pending">На согласовании</span>`
                    : `<label class="dir-row__switch">
                        <input type="checkbox" data-direction="${d.id}" ${dirState.active ? 'checked' : ''}>
                        <span></span>
                    </label>`}
            </div>
        `;
    }).join('');
}

function cityRowMarkup(city, state) {
    const cityState = state.cities[city.id];
    const districtsOffCount = cityState.districtsOff.length;
    const districtsOnCount = city.districts.length - districtsOffCount;
    const expanded = expandedCityId === city.id;
    const cityOn = cityState.cityOn || cityState.regionOn;

    return `
        <div class="geo-row${expanded ? ' geo-row--expanded' : ''}">
            <div class="geo-row__main">
                <div class="geo-row__info">
                    <div class="geo-row__name">${city.name}</div>
                    <div class="geo-row__meta">${cityLeadsCount30d(city.id)} заявок за 30 дней · заявка от ${formatMoney(minPriceForCity(city))}</div>
                </div>
                <div class="geo-row__toggles">
                    <label class="geo-row__toggle-label">
                        <input type="checkbox" class="geo-city-toggle" data-city="${city.id}" ${cityState.cityOn ? 'checked' : ''}>
                        <span>Город</span>
                    </label>
                    <label class="geo-row__toggle-label">
                        <input type="checkbox" class="geo-region-toggle" data-city="${city.id}" ${cityState.regionOn ? 'checked' : ''}>
                        <span>${city.regionShort === 'МО' || city.regionShort === 'ЛО' ? city.regionShort : 'Область'}</span>
                    </label>
                    <button type="button" class="geo-row__districts-btn" data-expand="${city.id}">Районы ${districtsOnCount} из ${city.districts.length}</button>
                </div>
                <label class="geo-row__main-switch">
                    <input type="checkbox" class="geo-main-toggle" data-city="${city.id}" ${cityOn ? 'checked' : ''}>
                    <span></span>
                </label>
            </div>
            ${expanded ? `
                <div class="geo-row__districts">
                    <div class="geo-row__districts-label">Районы</div>
                    <div class="geo-row__district-list">
                        ${city.districts.map(d => `
                            <button type="button" class="geo-district-chip${cityState.districtsOff.includes(d) ? ' off' : ''}" data-city="${city.id}" data-district="${d}">${d}</button>
                        `).join('')}
                    </div>
                    ${city.regionTowns.length ? `
                        <div class="geo-row__districts-label">Крупные населённые пункты области</div>
                        <div class="geo-row__towns">${city.regionTowns.join(', ')}</div>
                    ` : ''}
                </div>
            ` : ''}
        </div>
    `;
}

export function renderDirectionsSection(container) {
    const state = store.get();
    const connectedCount = store.connectedCitiesCount();

    container.innerHTML = `
        <div class="dir-grid">
            <div class="dir-card">
                <div class="dir-card__head">
                    <div class="dir-card__title">Направления</div>
                    <button type="button" class="dir-card__add" id="add-direction-open">+ Добавить</button>
                </div>
                <div class="dir-list">${directionsListMarkup(state)}</div>
            </div>

            <div class="dir-side">
                <div class="dir-card">
                    <div class="dir-card__title">Приём заявок</div>
                    <label class="dir-accept-row">
                        <span>
                            <b>Принимаем заявки</b>
                            <div class="dir-accept-row__sub">Заявки поступают по расписанию и лимиту</div>
                        </span>
                        <span class="dir-row__main-switch">
                            <input type="checkbox" id="accepting-toggle" ${state.acceptingLeads ? 'checked' : ''}>
                            <span></span>
                        </span>
                    </label>
                </div>

                <div class="dir-card">
                    <div class="dir-card__title">Дневной лимит</div>
                    <div class="dir-limit__value">${state.dailyLimit}</div>
                    <input type="range" min="5" max="80" step="5" id="daily-limit-slider" value="${state.dailyLimit}">
                    <div class="dir-limit__forecast">до ${formatMoney(estimateDailySpend(state))} в день</div>
                    <div class="dir-limit__today">Сегодня поступило ${state.todayCount}. ${state.todayCount >= state.dailyLimit ? 'После лимита приём продолжится завтра.' : ''}</div>
                </div>

                <div class="dir-card">
                    <div class="dir-card__title">Расписание</div>
                    <label class="dir-schedule__row">
                        <input type="checkbox" id="schedule-round" ${state.schedule.roundTheClock ? 'checked' : ''}>
                        <span>Круглосуточно</span>
                    </label>
                    <div class="dir-schedule__times" ${state.schedule.roundTheClock ? 'hidden' : ''} id="schedule-times">
                        <label>с <input type="time" id="schedule-from" value="${state.schedule.from}"></label>
                        <label>до <input type="time" id="schedule-to" value="${state.schedule.to}"></label>
                    </div>
                    <div class="dir-schedule__hint">Время московское. Для городов в другом часовом поясе расписание сдвигается автоматически.</div>
                </div>
            </div>
        </div>

        <div class="dir-card">
            <div class="dir-card__head">
                <div class="dir-card__title">География</div>
                <div class="dir-card__sub">в работе ${connectedCount} из 11 городов</div>
            </div>
            <div class="geo-list">${CITIES.map(c => cityRowMarkup(c, state)).join('')}</div>
        </div>

        <div class="dir-card">
            <div class="dir-card__title">Цена заявки по городам</div>
            <div class="price-ref">
                ${CITIES.map(c => `
                    <div class="price-ref__row">
                        <span>${c.name}</span>
                        <span>${formatMoney(minPriceForCity(c))}</span>
                    </div>
                `).join('')}
            </div>
        </div>
    `;

    container.querySelectorAll('[data-direction]').forEach(input => {
        input.addEventListener('change', () => {
            store.update(s => { s.directions[input.dataset.direction].active = input.checked; });
            renderDirectionsSection(container);
        });
    });

    container.querySelector('#accepting-toggle').addEventListener('change', e => {
        store.update(s => { s.acceptingLeads = e.target.checked; });
        updateHeaderAcceptState();
    });

    const limitSlider = container.querySelector('#daily-limit-slider');
    limitSlider.addEventListener('input', () => {
        container.querySelector('.dir-limit__value').textContent = limitSlider.value;
        container.querySelector('.dir-limit__forecast').textContent = `до ${formatMoney(estimateDailySpend({ ...state, dailyLimit: Number(limitSlider.value) }))} в день`;
    });
    limitSlider.addEventListener('change', () => {
        store.update(s => { s.dailyLimit = Number(limitSlider.value); });
    });

    container.querySelector('#schedule-round').addEventListener('change', e => {
        store.update(s => { s.schedule.roundTheClock = e.target.checked; });
        container.querySelector('#schedule-times').hidden = e.target.checked;
    });
    const fromInput = container.querySelector('#schedule-from');
    const toInput = container.querySelector('#schedule-to');
    if (fromInput) fromInput.addEventListener('change', () => store.update(s => { s.schedule.from = fromInput.value; }));
    if (toInput) toInput.addEventListener('change', () => store.update(s => { s.schedule.to = toInput.value; }));

    container.querySelectorAll('.geo-city-toggle').forEach(input => {
        input.addEventListener('change', () => {
            store.update(s => { s.cities[input.dataset.city].cityOn = input.checked; });
            renderDirectionsSection(container);
        });
    });
    container.querySelectorAll('.geo-region-toggle').forEach(input => {
        input.addEventListener('change', () => {
            store.update(s => { s.cities[input.dataset.city].regionOn = input.checked; });
            renderDirectionsSection(container);
        });
    });
    container.querySelectorAll('.geo-main-toggle').forEach(input => {
        input.addEventListener('change', () => {
            store.update(s => {
                s.cities[input.dataset.city].cityOn = input.checked;
                s.cities[input.dataset.city].regionOn = input.checked;
            });
            renderDirectionsSection(container);
        });
    });
    container.querySelectorAll('[data-expand]').forEach(btn => {
        btn.addEventListener('click', () => {
            expandedCityId = expandedCityId === btn.dataset.expand ? null : btn.dataset.expand;
            renderDirectionsSection(container);
        });
    });
    container.querySelectorAll('.geo-district-chip').forEach(chip => {
        chip.addEventListener('click', () => {
            store.update(s => {
                const cityState = s.cities[chip.dataset.city];
                const idx = cityState.districtsOff.indexOf(chip.dataset.district);
                if (idx === -1) cityState.districtsOff.push(chip.dataset.district);
                else cityState.districtsOff.splice(idx, 1);
            });
            renderDirectionsSection(container);
        });
    });

    container.querySelector('#add-direction-open').addEventListener('click', openAddDirectionModal);
}

function estimateDailySpend(state) {
    const activeIds = APPLIANCE_DIRECTIONS.filter(d => state.directions[d.id] && state.directions[d.id].active);
    if (!activeIds.length) return 0;
    const avgPrice = activeIds.reduce((sum, d) => sum + priceFor(d.id, CITIES[0]), 0) / activeIds.length;
    return avgPrice * state.dailyLimit;
}

function updateHeaderAcceptState() {
    const event = new CustomEvent('cabinet:header-refresh');
    document.dispatchEvent(event);
}

function openAddDirectionModal() {
    const modal = document.querySelector('#add-direction-modal');
    const list = document.querySelector('#add-direction-list');
    const state = store.get();
    const available = APPLIANCE_DIRECTIONS.filter(d => !state.directions[d.id] || (!state.directions[d.id].active && !state.directions[d.id].pending));

    list.innerHTML = available.length ? available.map(d => `
        <button type="button" class="cab-modal__list-item" data-add="${d.id}">
            <span>${d.title}</span>
            <span class="cab-modal__list-price">от ${formatMoney(priceFor(d.id, CITIES[0]))}</span>
        </button>
    `).join('') : '<div class="cab-modal__empty">Все направления уже подключены или на согласовании</div>';

    list.querySelectorAll('[data-add]').forEach(btn => {
        btn.addEventListener('click', () => {
            store.update(s => {
                s.directions[btn.dataset.add] = { active: false, pending: true };
            });
            modal.hidden = true;
            const section = document.querySelector('#cabinet-content');
            if (section) renderDirectionsSection(section);
        });
    });

    modal.hidden = false;
}
